import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback, useEffect } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";


import PrimaryButton from "../../../../../../common/components/primary_button";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";

import { DiarioObrasParalisacoesForm, DiarioObrasParalisacoesSchema } from "../../../schemas/DiarioObrasParalisacoes/diario_obras_paralisacoes";
import { FormTimeRangePickerInput } from "../../../../../../common/components/default_time_range_picker_input";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";


type Props = {
  open: boolean,
  saving: boolean,
  selectedParalisacoes: DiarioObrasParalisacoesForm | null,
  IdDiarioObras: number;
  onSubmit: (form: DiarioObrasParalisacoesForm) => void,
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void,
  onClose: () => void,
};

export const ParalisacoesModal = ({
  open,
  saving,
  IdDiarioObras,
  selectedParalisacoes,
  onOpenChangeHistory,
  onSubmit,
  onClose,
}: Props) => {
  const hookForm = useForm<DiarioObrasParalisacoesForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(DiarioObrasParalisacoesSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedParalisacoes) {
        hookForm.reset({
          IdDiarioObrasParalisacoes: selectedParalisacoes.IdDiarioObrasParalisacoes,
          IdDiarioObras: selectedParalisacoes.IdDiarioObras,
          Assunto: selectedParalisacoes.Assunto,
          HorarioFim: selectedParalisacoes.HorarioFim,
          HorarioInicio: selectedParalisacoes.HorarioInicio,
          Motivo: selectedParalisacoes.Motivo,
          TempoParalisacao: selectedParalisacoes.TempoParalisacao,
        });
      }
      } else {
        hookForm.reset({
          IdDiarioObrasParalisacoes: undefined,
          IdDiarioObras: IdDiarioObras,
          Assunto: "",
          HorarioFim: null,
          HorarioInicio: null,
          Motivo: "",
          TempoParalisacao: null,
        });
      }
  }, [hookForm, open, IdDiarioObras, selectedParalisacoes]);

  const handleChangeHistory = useCallback(() => {
    if (selectedParalisacoes) {
      onOpenChangeHistory(selectedParalisacoes.IdDiarioObrasParalisacoes, LogTipoTabela.DIARIO_OBRAS_PARALISACOES);
    }
  }, [selectedParalisacoes, onOpenChangeHistory]);
  const handleSubmit = useCallback((form: DiarioObrasParalisacoesForm) => {
    if (!saving){
      onSubmit(form);
      // hookForm.reset(); 
    } 
  }, [onSubmit, saving]);

  const handleClose = useCallback(() => {
    if (!saving){
      onClose();
      hookForm.reset(); 
    } 
  }, [hookForm, onClose, saving]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="md"
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(handleSubmit),
        }
      }}
       sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "42rem",
          },
        },
      }}
      >
      <DialogTitle>
        Paralisações
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}>
          <FormContainer title={selectedParalisacoes ? "Editar" : "Cadastrar"} arrangement="fullRow">
            <>
            <DefaultFormInput
                name='Motivo'
                label="Motivo"
                reactHookForm={hookForm}
              />
               <div className="md:col-span-2">
                  <FormTimeRangePickerInput
                    startName="HorarioInicio"
                    endName="HorarioFim"
                    label="Intervalo da Paralisação"
                    required={true}
                    reactHookForm={hookForm}
                  />
                </div>
                <DefaultFormInput
                  name='Assunto'
                  label="Assunto"
                  reactHookForm={hookForm}
                />
                <DefaultFormInput
                  name='TempoParalisacao'
                  label="Tempo Paralisação:"
                  readOnly={true}
                  reactHookForm={hookForm}
                />
            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-between flex p-4 gap-4">
          <div className="w-[220px]">
            {
              isNotNullOrUndefined(selectedParalisacoes) &&
              <PrimaryButton
              buttonColor="yellow"
              onClick={handleChangeHistory}>
                <span className="text-xs">
                  Historico de alterações
                </span>
              </PrimaryButton>
            }
          </div>
          <div className="flex flex-row gap-2 w-full justify-end">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton
                  buttonColor="primary-green">
                  Salvando...
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  type="submit"
                  buttonColor="primary-green">
                  Salvar
                </PrimaryButton>
              )}
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}